import { DigitalMeterLogApi } from "../api"

export class DigitalMeterLog {
  constructor() {}
  
  static async getDigitalMeterLogBetweenDateByMarket(payload) {
    const { data } = await DigitalMeterLogApi.getDigitalMeterLogBetweenDateByMarket(payload);
    return data.result
  }
}